export const selectConfig = {
  /**
   * When true, every selection adds to the current one, as if Shift was held.
   * Provides the additive selection on touch devices, where there is no
   * keyboard shortcut available.
   */
  additive: false,
};
